export { default } from './FooterHint';